import React, { useState, useEffect } from 'react';
import {menuData} from "../../data/menuData";
// @ts-ignore
const title = menuData[9].children[4].title;
const description = `The opening balance is your business's financial starting point,
 detailing all assets and debts on a specific date. Without this crucial initial record,
  all subsequent financial reports and data will be inaccurate, making it impossible to 
  truly understand your business's performance.`;

const images = [
    '/images/settings/opening-balance/opening-balance-overview.png', // 0
    '/images/settings/opening-balance/opening-balance-collapse.png', // 1
    '/images/settings/opening-balance/opening-balance-edit.png', // 2
    '/images/settings/opening-balance/opening-balance-box.png', // 3
];

const topic = [
    {
        title: 'Home',
        description: ``,
        id: 'home',
    },
    {
        title: 'Edit Opening Balance',
        description: `.`,
        id: 'edit-opening-balance',
    },
];

const OpeningBalance: React.FC = () => {
    const [activeId, setActiveId] = useState(topic[0].id);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const newActiveId = entry.target.id;
                        setActiveId(newActiveId);
                        window.history.replaceState(null, '', `#${newActiveId}`);
                    }
                });
            },
            {
                root: null,
                rootMargin: '-50% 0% -50% 0%',
                threshold: 0,
            }
        );

        topic.forEach((item) => {
            const section = document.getElementById(item.id);
            if (section) {
                observer.observe(section);
            }
        });

        return () => {
            observer.disconnect();
        };
    }, []);

    const handleItemClick = (id: string) => {
        setActiveId(id);
    };

    return (
        <div className="max-w-4xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">
                {/* Chart of Accounts */}
                <div className="mb-6"   id={topic[0].id}>
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <img
                            src={images[0]}
                            alt={title}
                            className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        <p className="text-gray-600 my-4">
                            To see more data, click the arrow.
                        </p>
                        <img
                            src={images[1]}
                            alt={title}
                            className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                    </div>
                </div>

                {/* Edit Opening Balance */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6"  id={topic[1].id}>
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">{topic[1].title}</h2>
                    <p className="text-gray-600 mb-4">
                        To edit the Opening balance, click Edit.
                    </p>
                    <img
                        src={images[2]}
                        alt={title}
                        className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>

                </div>
            </div>

            {/* side route */}
            <div className="fixed w-1/5 right-2">
                <ul>
                    {topic.map((item) => (
                        <li key={item.id} className="mb-4">
                              <span className="text-xs">
                                    <a
                                        className={`hover:text-blue-700 border-l p-4 ${
                                            activeId === item.id ? 'text-blue-700 font-bold border-blue-700' : ''
                                        }`}
                                        href={`#${item.id}`}
                                        onClick={() => handleItemClick(item.id)}
                                    >
                                      {item.title}
                                    </a>
                              </span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default OpeningBalance;
